export default {
  config: {
    data_table_expire_days: 366,
  },
  tags: ["limited-to-xdr", "limited-to-xdr-trial"],
  api: [
    { rule: ".*", allow: true },
    { rule: "bq_summary.read", allow: true },
  ],
  page: [
    { rule: "getstarted/.*", allow: false },
    { rule: "dashboard/.*", allow: true },
    { rule: "settings/sensors", allow: false },
    { rule: "settings/blocklists", allow: false },
    { rule: "settings/singlesignon", allow: false },
    { rule: "settings/.*", allow: true },
    { rule: "reporting/.*", allow: true },
    { rule: "blumiraagent/.*", allow: true },
    { rule: "user/.*", allow: true },
    { rule: "investigate/search", allow: true },
  ],
};
